(function(app, $) {
    var $cache = {};

    function initializeCache() {
        $cache.body = $('body');
        $cache.logoBasketContainer = $cache.body.find('div#header div#logo-basket-container');
    }

    function initializeEvents() {
        // Add to cart button
        $cache.body.on('click', 'div.catalog div.add-to-basket a.add-to-basket', function(e) {
            e.preventDefault();

            var $ajaxURL = $cache.body.attr('data-addToBasketURL');
            var $quantity = $(this).siblings('select.quantity-to-add');
            var $menuID = $(this).attr('data-menu-id');

            if($quantity.length > 0 && $ajaxURL.length > 0 && $menuID.length > 0) {
                $.ajax({
                    type : 'POST',
                    url  : $ajaxURL,
                    data : 'menuID=' + $menuID + '&quantity=' + $quantity.val()
                }).done(function(res) {
                    $cache.logoBasketContainer.html(res);

                    // Load mobile quantity
                    var quantity = parseInt($cache.logoBasketContainer.find('a#logo-basket span.quantity').text());
                    var $quantityMobile = $('a.logo-basket span.quantity');

                    if($quantityMobile.length > 0) {
                        $('a.logo-basket span.quantity').text(quantity);
                    }
                    else {
                        $('a.logo-basket').append('<span class="quantity">' + quantity + '</span>');
                    }

                    if(quantity > 0) {
                        $('a.logo-basket span.quantity').show();
                    }
                    else {
                        $('a.logo-basket span.quantity').hide();
                    }

                    $cache.logoBasketContainer.find('div#minibasket-container').slideDown(300, function() {
                        setTimeout(function() {
                            $cache.logoBasketContainer.find('div#minibasket-container').slideUp(300)
                        }, 4000);
                    });
                });
            }
        });
    }

    app.components = app.components || {};
    app.components.basket = {
        init : function() {
            if(app.preferences.env === 'production' && app.preferences.modules.enableCommerce) {
                initializeCache();
                initializeEvents();
            }
        }
    };
}(window.app = window.app || {}, jQuery));
